<template>
    <div>
        <div v-if="$route.params.reInputFlg == 0" class="header_unit header_bg_blue">
            <div class="header_box">
                <div class="menu_center">
                    <p class="menu_center_tex_s">履歴</p>
                    <p class="menu_center_tex_l">{{title}}</p>
                </div>
            </div>
        </div>
        <div v-if="$route.params.reInputFlg == 1" class="header_unit header_bg_red">
            <div class="header_box">
                <div class="menu_center">
                    <p class="menu_center_tex_s">履歴</p>
                    <p class="menu_center_tex_l">【再計測】{{title}}</p>
                </div>
            </div>
        </div>
        <div class="main_unit">
            <pulse-loader class="w-100 text-center" :loading="isInitLoading"></pulse-loader>
            <div v-show="!isInitLoading">
                <div class="check_tyori_tbl_unit wd976 tbl_ht_none tbl_bg_blue">
                    <table>
                        <tbody>
                            <tr v-if="rowspan == 2">
                                <th class="wd240 checkSetting_text_align" rowspan="2" >記入者</th>
                                <th class="wd70 checkSetting_text_align" rowspan="2" >登録時刻</th>

                                <th class="checkSetting_text_align text_white_space" v-if="dailyCheckMenuList.cookingHeaderList[0].inputType == 6 && dailyCheckMenuList.cookingHeaderList[0].displayFlg == 1"
                                    rowspan="2">{{dailyCheckMenuList.cookingHeaderList[0].lowerHeaderName}} </th>
                                <th class="checkSetting_text_align text_white_space" v-if="hedderUpname1 !== '' && hedderUpname1 !== null" :colspan="hedderList1">{{hedderUpname1}}</th>
                                <th class="checkSetting_text_align text_white_space" v-if="hedderUpname2 !== '' && hedderUpname2 !== null" :colspan="hedderList2">{{hedderUpname2}}</th>
                                <th class="checkSetting_text_align text_white_space" v-if="hedderUpname3 !== '' && hedderUpname3 !== null" :colspan="hedderList3">{{hedderUpname3}}</th>
                                <th class="checkSetting_text_align text_white_space" v-if="hedderUpname4 !== '' && hedderUpname4 !== null" :colspan="hedderList4">{{hedderUpname4}}</th>
                                <th rowspan="2" v-for="HeaderList in headerFilter2" :key="'hdInfo_' + HeaderList.cookingCheckHeaderNo" class="wd70 checkSetting_text_align text_white_space" :id="HeaderList.cookingCheckHeaderNo">
                                  <label>{{HeaderList.lowerHeaderName}}</label>
                                </th>
                                <th rowspan="2"  class="checkSetting_text_align">改善措置／コメント</th>
                            </tr>
                            <tr>
                                <th class="wd240 checkSetting_text_align" v-if="rowspan == 1">記入者</th>
                                <th class="wd70 checkSetting_text_align" v-if="rowspan == 1">登録時刻</th>

                                <th v-for="HeaderList in headerFilter1" :key="'hdInfo_' + HeaderList.cookingCheckHeaderNo" class="wd70 checkSetting_text_align text_white_space" :id="HeaderList.cookingCheckHeaderNo">
                                    <label>{{HeaderList.lowerHeaderName}}</label>
                                </th>

                                <th class="checkSetting_text_align" v-if="rowspan == 1">改善措置／コメント</th>
                            </tr>
                        </tbody>
                        <tbody>
                            <tr v-for="List in dailyCheckMenuListHistory.cookingCheckHistory" :key="List.cookingCheckHeaderNo">
                                <td class="cooking_background-color_def2 tbl_tex_left">{{List.staffName}} <br>
                                <td class="cooking_background-color_def2 tbl_tex_left">{{List.createdDatetime}}</td>

                                <td v-for="chList in List.checkedList" :key="chList.cookingCheckHeaderNo" :class="changeColor(chList.status)"  >

                                    <label v-if="chList.resultValue == '1' && (chList.status == 1 || chList.status == 4) && chList.inputType== 4"><p class="icn_blue_td"><i class="far fa-circle"></i></p></label>
                                    <label v-else-if="chList.resultValue == '0' && (chList.status == 1 || chList.status == 4) && chList.inputType== 4"><p class="icn_red_td"><i class="fas fa-times"></i></p></label>

                                    <label v-else-if="chList.resultValue == '1' && (chList.status == 1 || chList.status == 4) && chList.inputType== 6">
                                        <p class="icn_blue_s_td" ><i class="fas fa-check"></i></p></label>

                                    <label class="text_white_space_pre_wrap" v-else-if="chList.resultValue !== null  && (chList.status == 1 || chList.status == 4) && (chList.inputType== 1
                                           || chList.inputType== 2 || chList.inputType== 3 || chList.inputType== 5 || chList.inputType== 7)">{{chList.resultValue}}</label>

                                </td>
                                <td class="cooking_background-color_def2 tbl_tex_left text-wrap">{{List.comment}}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import PulseLoader from '@/app/components/PulseLoader.vue'
    export default {
        name: 'CookingCommentHistory',
        components: {
            PulseLoader,
        },
        data: function (){
            return {
                isInitLoading:true,
                title:'',
                hedderUpname1:"",
                hedderUpname2:"",
                hedderUpname3:"",
                hedderUpname4:"",
                hedderList1:"1",
                hedderList2:"1",
                hedderList3:"1",
                hedderList4:"1",
                rowspan:0,
                dailyCheckMenuList: {
                    "cookingCheckButtonId": null,
                    "cookingCheckPageId": null,
                    "manualFilePath": "",
                    "informationFilePath": "",
                    "cookingHeaderList": [
                        {
                            "cookingCheckHeaderId": null,
                            "cookingCheckHeaderNo": null,
                            "upperHeaderName": "",
                            "lowerHeaderName": "",
                            "displayFlg": null,
                            "inputType": null,
                        }
                    ],
                    "cookingList": [
                        {
                            "cookingId": null,
                            "cookingName": "",
                            "cookingNameNo": null,
                        }
                    ]
                },
                //重要管理項目チェック履歴取得(キー名重複のため名前変更)
                dailyCheckMenuListHistory: {
                    "cooking_id": null,
                    "cookingCheckHistory": [
                        {
                            "staffName": "",
                            "createdDatetime": "",
                            "checkedList": [
                                {
                                    "cookingCheckItemId": null,
                                    "status": null,
                                    "resultValue": "",
                                    inputType:null
                                }
                            ],
                            "comment": ""
                        }
                    ]
                },
            }
        },
        computed: {
            headerFilter1:function(){
                if(this.rowspan == 2) {
                    return this.dailyCheckMenuList.cookingHeaderList.filter(e => e.inputType !== 6 && e.displayFlg == 1 && (e.upperHeaderName !== '' && e.upperHeaderName !== null ))
                } else {
                    return this.dailyCheckMenuList.cookingHeaderList.filter(e => e.inputType !== 6 && e.displayFlg == 1 )
                }
            },
            headerFilter2:function(){
                return this.dailyCheckMenuList.cookingHeaderList.filter(e => e.inputType !== 6 && e.displayFlg == 1 && (e.upperHeaderName === '' || e.upperHeaderName === null ))
            },
            brandPath: function () {
                return this.$store.getters['brand/path']
            },
        },
        created: function(){
            this.historyData();
        },
        methods :{
            async historyData() {

                var apiResponseFlg = true;

                //重要管理項目チェック内容取得
                var brandId = this.$store.getters['brand/id'];
                var storeId = this.$store.getters['store/data'].store_id;
                var cookingCheckButtonId = this.$route.params.subMenuId;
                var remesure_flg = this.$route.params.reInputFlg;
                var url = this.$apiEndpoint + 'user/brand/' + brandId + '/store/' + storeId + '/cooking_menu/' + cookingCheckButtonId + '?remeasure_flg=' + remesure_flg;

                await this.$axios
                    .get(url)
                    .then(response => (this.dailyCheckMenuList = response.data))
                    .catch((err) => {
                        let error = {
                            button: {
                                path: {name: 'top', params:{brandPath: this.brandPath}}
                            }}
                        apiResponseFlg = false;
                        if (err.customError) {
                            error = Object.assign(error, err.customError)
                        }
                        this.$store.dispatch('error/setError', error).then(this.$router.push({name: 'error'}))
                    });

                // API処理判定
                if(!apiResponseFlg){
                    // 1回目の呼び出しではここでlodingを停止
                    this.isInitLoading = false;
                    return null;
                }

                var cookingId = this.$route.params.cookingId;
                var url2 = this.$apiEndpoint + 'user/brand/' + brandId + '/store/' + storeId + '/cooking_check/' + cookingId + '/history?remeasure_flg=' + remesure_flg;

                await this.$axios
                    .get(url2)
                    .then(response => (this.dailyCheckMenuListHistory = response.data))
                    .catch((err) => {
                        let error = {
                            button: {
                                path: {name: 'top', params:{brandPath: this.brandPath}}
                            }}
                        apiResponseFlg = false;
                        if (err.customError) {
                            error = Object.assign(error, err.customError)
                        }
                        this.$store.dispatch('error/setError', error).then(this.$router.push({name: 'error'}))
                    }).finally(()=> this.isInitLoading = false);

                // API処理判定
                if(!apiResponseFlg){
                    return null;
                }

                //ヘッダーの行列を設定する
                for( var T=0 ; T < this.dailyCheckMenuList.cookingHeaderList.length ; T++){

                    //列セルの結合数のチェック
                    if(this.dailyCheckMenuList.cookingHeaderList[T].upperHeaderName !== "" &&
                        this.dailyCheckMenuList.cookingHeaderList[T].upperHeaderName !== null){
                        this.rowspan = 2;
                        break;
                    }else{
                        this.rowspan = 1;
                    }
                }

                //カラムの結合処理
                var colspanInt = 0;
                var groupId = 1;
                var serchStr= '';
                for( var L=0 ; L < this.dailyCheckMenuList.cookingHeaderList.length ; L++){

                    var upperHdName = this.dailyCheckMenuList.cookingHeaderList[L].upperHeaderName;
                    if(serchStr !== upperHdName && this.dailyCheckMenuList.cookingHeaderList[L].displayFlg == 1){
                        var dddd = this.dailyCheckMenuList.cookingHeaderList.filter(e => e.upperHeaderName == upperHdName && e.displayFlg == 1 )
                        colspanInt = dddd.length;
                        switch (groupId) {
                            case 1:
                                this.hedderList1 = String(colspanInt);
                                this.hedderUpname1 = upperHdName;
                                serchStr = upperHdName;
                                groupId = groupId +1 ;
                                break;
                            case 2:
                                this.hedderList2 = String(colspanInt);
                                this.hedderUpname2 = upperHdName;
                                serchStr = upperHdName;
                                groupId = groupId +1 ;
                                break;
                            case 3:
                                this.hedderList3 = String(colspanInt);
                                this.hedderUpname3 = upperHdName;
                                serchStr = upperHdName;
                                groupId = groupId +1 ;
                                break;
                            case 4:
                                this.hedderList4 = String(colspanInt);
                                this.hedderUpname4 = upperHdName;
                                serchStr = upperHdName;
                                groupId = groupId +1 ;
                                break;
                        }
                    }
                }


                // 調理名取得
                for(var tyoriCount=0 ; tyoriCount < this.dailyCheckMenuList.cookingList.length ; tyoriCount++){
                    if(this.dailyCheckMenuList.cookingList[tyoriCount].cookingId == cookingId){
                        this.title = this.dailyCheckMenuList.cookingList[tyoriCount].cookingName
                        break;
                    }
                }

                // 履歴のデータにInputtypeを埋め込む
                var headerFilterAllData = this.headerFilterAll();
                var cookingCheckHistoryData = this.dailyCheckMenuListHistory.cookingCheckHistory

                // 履歴データの並び順で、ヘッダーのinputTypeを設定する
                for(var tyoriHistoryCount=0 ; tyoriHistoryCount < cookingCheckHistoryData.length ; tyoriHistoryCount++){

                    // 履歴内の1データ取得
                    var checkedListData =  cookingCheckHistoryData[tyoriHistoryCount].checkedList
                    for(var tyoriHistoryListCount=0 ; tyoriHistoryListCount < checkedListData.length ; tyoriHistoryListCount++){

                        // 履歴データのオブジェクト取得
                        var checkedListObj = checkedListData[tyoriHistoryListCount];
                        checkedListObj['inputType'] = headerFilterAllData[tyoriHistoryListCount].inputType;
                        this.dailyCheckMenuListHistory.cookingCheckHistory[tyoriHistoryCount].checkedList.splice(tyoriHistoryListCount,1,checkedListObj);
                    }
                }

            },
            dateFormat(){
                let nowDate = new Date();
                let year = nowDate.getFullYear();
                let month = ("0" + (nowDate.getMonth()+1)).slice(-2);
                let day = ("0" + nowDate.getDate()).slice(-2);

                let format_str = 'YYYYMMDD'
                format_str = format_str.replace(/YYYY/g,year);
                format_str = format_str.replace(/MM/g,month);
                format_str = format_str.replace(/DD/g,day);
                return format_str;
            },
            headerFilterAll:function(){
                return this.dailyCheckMenuList.cookingHeaderList.filter(e => e.displayFlg == 1 )
            },
            changeColor: function (status) {
                if (status == 2) {
                    return 'cooking_background-color_no-input'
                }
                else if (status == 3) {
                    return 'cooking_background-color_disabled'
                }
                return 'cooking_background-color_input'
            }
        }
    }
</script>
